import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StatusService {

  
    getOrderStatus(){
     return [
  {
  "name":"Pinpont Pen", "photo":"assets/img/products/pinpoint-ballpen.jpg", "quantity":2, "date":"02-02-2020", "price":100, "status":"packed"
  } ]
    }
  
  constructor() { }
}
